<hg-contaier>
  <div class="logo-container">
    <app-logo [generalSettingsData]="generalSettingsData"></app-logo>
  </div>

  <div class="main-header-content">
    <div class="main-header-left-content" *ngIf="generalSettingsData">
      <button class="no-style menu-btn" (click)="toggleSidebar()">
        <mat-icon [svgIcon]="'menu'" class="square-icon menu-icon"></mat-icon>
      </button>

      <!-- todo: add skeleton -->
      <div class="portal-type-container">
        <img class="portal-type-icon" *ngIf="portalTypeIconUrl" [src]="portalTypeIconUrl">
        <h3 class="portal-type-text" *ngIf="portalTypeTitle">{{portalTypeTitle}}</h3>
      </div>
    </div>

    <div class="left-side-container">
      <app-header-actions [generalSettings]="generalSettingsData"></app-header-actions>

      <app-account-info [generalSettingsData]="generalSettingsData"  class="account-info-component"></app-account-info>
    </div>
  </div>
</hg-contaier>